import apiClient from "@/libs/axios";
// import store from "@/state/store";
// import router from "@/router";

export const state = {
    data: [],
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, vendor: {...item.vendor, is_active: data.vendor.is_active}} : item)
    },
};

export const actions = {
    async get({ commit }) {
        await apiClient
            .get(`api/v1/opening-times/my-opening-times`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);
    },
    async update({ commit }, data) {
        console.log(data);
        commit('app/loadingStart', null, {root: true});

        await apiClient
            .patch(`api/v1/opening-times/update`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
                commit('app/loadingFinish', null, {root: true});
            })
            .catch(error => {
                commit('app/loadingFinish', null, {root: true});
                throw error;
            },);
    }
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getTotal(state) {
        return state.total;
    },
};
